import { baseApi } from '@shared/api/baseApi'

export interface SendCodeResponse {
  is_new_user: boolean
  next_resend: string
  expired_at: string
  code: string | null
}

export interface VerifyCodeResponse {
  user: { user_id: number; name: string }
  is_new_user: boolean
}

// (будет использоваться для онбординга новых юзеров)

const normalizeEmail = (email: string) => email.trim().toLowerCase()

export const sendCode = async (
  email: string,
  allowRegistration?: boolean
): Promise<SendCodeResponse> => {
  const payload: { email: string; allow_registration?: boolean } = {
    email: normalizeEmail(email)
  }
  if (allowRegistration) payload.allow_registration = true
  const { data } = await baseApi.post<SendCodeResponse>('/api/web-auth/send-code', payload)
  return data
}

export const resendCode = async (email: string): Promise<SendCodeResponse> => {
  const { data } = await baseApi.post<SendCodeResponse>('/api/web-auth/resend-code', {
    email: normalizeEmail(email)
  })
  return data
}

export const verifyCode = async (email: string, code: string): Promise<VerifyCodeResponse> => {
  const { data } = await baseApi.post<VerifyCodeResponse>('/api/web-auth/verify-code', {
    email: normalizeEmail(email),
    code
  })
  return data
}

export const logout = async (): Promise<void> => {
  await baseApi.post('/api/web-auth/logout')
}
